import { use } from 'react';

import { AppModeContext } from './context';

export function useAppMode() {
  const context = use(AppModeContext);
  if (!context) {
    throw new Error('useAppMode must be used within an AppModeProvider');
  }

  return context;
}
